import React from 'react';
import { ScatterChart } from '@mui/x-charts/ScatterChart';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { getFieldValue, toNumber } from './widgetData';

const ScatterBubbleWidget = ({ widget, rows, bubble = false }) => {
  const { title, xField, yField, sizeField, labelField, showLegend } = widget.params || {};
  const points = rows
    .map((row, index) => ({
      id: row.id || row.rowId || index,
      x: toNumber(getFieldValue(row, xField)),
      y: toNumber(getFieldValue(row, yField)),
      z: bubble ? toNumber(getFieldValue(row, sizeField)) : undefined,
      label: labelField ? getFieldValue(row, labelField) : undefined,
    }))
    .filter((point) => point.x != null && point.y != null);

  if (!points.length) {
    return (
      <WidgetCard
        title={title || (bubble ? 'Bubble' : 'Scatter')}
        subtitle={`${xField} vs ${yField}`}
        testId={`report-widget-${widget.id || widget.type}`}
      >
        <WidgetEmptyState message="Scatter data is not available yet." />
      </WidgetCard>
    );
  }

  return (
    <WidgetCard
      title={title || (bubble ? 'Bubble' : 'Scatter')}
      subtitle={`${xField} vs ${yField}`}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      <ScatterChart
        height={240}
        series={[{ data: points, label: title || 'Series' }]}
        zAxis={bubble ? [{ id: 'bubble', scaleType: 'linear' }] : undefined}
        legend={{ hidden: !showLegend }}
      />
    </WidgetCard>
  );
};

export default ScatterBubbleWidget;
